/** @namespace styleTypes */
const styleTypes = {
  ok: "ok",
  neutral: "neutral",
  error: "error",
};
export default styleTypes;
